<template>
  <div class="container">
    <div class="row">
      <div class="col-12">
        <div class="box mt-2">
          <div class="heading">
            <h3>{{ $t('data_providers.title') }}</h3>
            <button class="btn btn-primary" @click="openCreateOffcanvas">{{ $t('data_providers.register') }}</button>
          </div>
          <table v-if="page" class="table table-sm table-list table-hover mt-2">
            <thead>
            <tr>
              <th>{{ $t('data_providers.name') }}</th>
              <th>{{ $t('data_providers.status') }}</th>
              <th>{{ $t('data_providers.description') }}</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="dataProvider in page.items" @click="moveToShow(dataProvider.id)" class="pointer">
              <td>{{ dataProvider.name }}</td>
              <td class="text-center">{{ $t(dataProvider.status.description) }}</td>
              <td>{{ dataProvider.description }}</td>
            </tr>
            </tbody>
          </table>
          <Pagination v-if="page" :page="page" class="mt-3" v-model="filter" @change="changePage"/>
        </div>
      </div>
    </div>
  </div>

  <DataProviderCreateOffcanvas @create="fetch"/>
</template>

<script setup>
import {ref} from 'vue';
import {useRouter} from 'vue-router';
import usePagination from '../../../composables/usePagination';
import useOffcanvas from '../../../composables/useOffcanvas';
import Pagination from '../../../components/Pagination.vue';
import DataProviderFilter from '../../../filters/admin/DataProviderFilter';
import DataProviderCreateOffcanvas from './DataProviderCreateOffcanvas.vue';

const {openOffcanvas: openCreateOffcanvas} = useOffcanvas('dataProviderCreateOffcanvas');

const router = useRouter();

const filter = ref(new DataProviderFilter());

const {page, fetch, changePage} = usePagination(filter.value);

/**
 * Navigate to data provider details
 *
 * @param dataProviderId
 */
const moveToShow = dataProviderId => {
  router.push({name: 'admin.data-providers.show', params: {id: dataProviderId}});
};
</script>